import _ from "lodash";
import {colors, responsiveFontSizes} from "@material-ui/core";
import {createTheme} from '@material-ui/core/styles'
import {THEMES} from "src/constants";
import {strongShadows} from "./shadows";
import typography from "./typography";

const baseOptions = {
    direction: "ltr",
    typography,
    overrides: {
        MuiLinearProgress: {
            root: {
                borderRadius: 3,
                overflow: "hidden"
            }
        },
        MuiListItemIcon: {
            root: {
                minWidth: 32
            }
        },
        MuiChip: {
            root: {
                backgroundColor: "rgba(0,0,0,0.075)"
            }
        }
    }
};

const themesOptions = [
    {
        name: THEMES.LIGHT,
        palette: {
            type: "light",
            background: {
                default: colors.common.white,
                dark: "#f4f6f8",
                paper: colors.common.white
            },
            primary: {
                contrastText: "#ffffff",
                main: "#1c3f6d"
            },
            secondary: {
                contrastText: "#ffffff",
                main: "#1c3f6d"
            },
            warning: {
                contrastText: "#ffffff",
                main: "#fcba31"
            },
            error: {
                contrastText: "#ffffff",
                main: "#db4d4c"
            },
            success: {
                contrastText: "#ffffff",
                main: "#19c486"
            },
            info: {
                contrastText: "#ffffff",
                main: "#17ace3"
            }
        }
    },
    {
        name: THEMES.DARK,
        palette: {
            type: "dark",
            action: {
                active: "rgba(255, 255, 255, 0.54)",
                hover: "rgba(255, 255, 255, 0.04)",
                selected: "rgba(255, 255, 255, 0.08)",
                disabled: "rgba(255, 255, 255, 0.26)",
                disabledBackground: "rgba(255, 255, 255, 0.12)",
                focus: "rgba(255, 255, 255, 0.12)"
            },
            background: {
                default: "#282C34",
                dark: "#1c2025",
                paper: "#282C34"
            },
            primary: {
                contrastText: "#ffffff",
                main: "#1c3f6d"
            },
            secondary: {
                contrastText: "#ffffff",
                main: "#17ace3"
            },
            warning: {
                contrastText: "#ffffff",
                main: "#fcba31"
            },
            error: {
                contrastText: "#ffffff",
                main: "#db4d4c"
            },
            success: {
                contrastText: "#ffffff",
                main: "#19c486"
            },
            info: {
                contrastText: "#ffffff",
                main: "#17ace3"
            },
            text: {
                primary: "#e6e5e8",
                secondary: "#adb0bb"
            }
        },
        shadows: strongShadows
    }
];

export const createCustomTheme = (config = {}) => {
    let themeOptions = themesOptions.find(theme => theme.name === config.theme);

    if (!themeOptions) {
        console.warn(new Error(`The theme ${config.theme} is not valid`));
        [themeOptions] = themesOptions;
    }

    let theme = createTheme(_.merge({}, baseOptions, themeOptions, {direction: config.direction}));

    if (config.responsiveFontSizes) {
        theme = responsiveFontSizes(theme);
    }

    return theme;
};
